<template>
  <div class="sensor-setup" :class="{inline: inline}">
    <div class="triangle"></div>
    <div class="title">
      <span>{{ $t(`metrics.${sensor.name.toLowerCase().replaceAll(" ","_").replace("%","_")}`) }}</span>
    </div>
    <div class="slider">
        <div class="slider__header">{{ $t('slider.header.critical') }}</div>
      <vue-slider
        class="critical"
        v-model="critValues"
        tooltip="always"
        :data="customData"
        :enable-cross="false"
        :min="Number(sensor.minValue)"
        :max="Number(sensor.maxValue)"
        :tooltip-formatter="val => `${val}${sensor.unit}`"
      ></vue-slider>
    </div>
    <div class="slider">
      <div class="slider__header">{{ $t('slider.header.attention') }}</div>
      <vue-slider
        class="attention"
        ref="attentionSlider"
        v-model="attentionValues"
        tooltip="always"
        :data="customData"
        :enable-cross="false"
        :min="Number(sensor.minValue)"
        :max="Number(sensor.maxValue)"
        :tooltip-formatter="val => `${val}${sensor.unit}`"
      ></vue-slider>
    </div>
    <div v-if="!inline" class="footer">
      <button @click="applyNewValues">{{ $t('buttons.apply') }}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SensorSetup',
  props: {
    sensor: {
      type: Object,
      // validator: obj => {
      //   return Object.keys(obj).every(field =>
      //     ['name', 'label', 'unit', 'min', 'max'].includes(field),
      //   );
      // },
    },
    inline: {
      type: Boolean,
      dafault: false,
    },
  },
  data() {
    return {
        critValues:       [this.sensor.minCrit, this.sensor.maxCrit],
        attentionValues:  [this.sensor.minAttention, this.sensor.maxAttention],
        slidersEqualedMin: false,
        slidersEqualedMax: false,
    };
  },
  computed:{
    customData(){
      return this.sensor.maxValue > 1000 ? [0, 1, 3, 20, 50, 80, 100, 150, 320, 500, 1000, 10000, 25000, 32000, 100000, 120000, 150000] : null;
    }
  },
  watch: {
      critValues(newValues, oldValues) {
          //if there has been change on the slider and it should continue to check.
          if (newValues[0] !== oldValues[0]) {
              //new critical min value is higher than attention min value so we change attention min
              if (newValues[0] > this.attentionValues[0]) {
                  this.$nextTick(() => {
                      this.$refs.attentionSlider.setValue([newValues[0], this.attentionValues[1]]);
                      //this means critical touched attention so the should slide back together
                      this.slidersEqualedMin = true;
                  });
              } else {
                  //this selects the highest value of low values to check even if attention moved
                  let newHigh = this.attentionValues[0] < this.sensor.minAttention ? this.sensor.minAttention : this.attentionValues[0];
                  if (newValues[0] > newHigh) {
                      //move changed attention with critical
                      this.$nextTick(() => {
                          this.$refs.attentionSlider.setValue([newValues[0], this.attentionValues[1]]);
                      });
                  //this moves the attention value to the last stored value of attention slider
                  } else if (newValues[0] < newHigh && newValues[0] >= this.sensor.minAttention && this.slidersEqualedMin) {
                      this.$nextTick(() => {
                          this.$refs.attentionSlider.setValue([newValues[0], this.attentionValues[1]]);
                      });
                  } else {
                      this.slidersEqualedMin = false;
                  }
              }
          }
          if (newValues[1] !== oldValues[1]) {
              if (newValues[1] < this.attentionValues[1]) {
                  this.$nextTick(() => {
                      this.$refs.attentionSlider.setValue([this.attentionValues[0], newValues[1]]);
                      this.slidersEqualedMax = true;
                  });
              } else {
                  let newLow = this.attentionValues[1] > this.sensor.maxAttention ? this.sensor.maxAttention : this.attentionValues[1];
                  if (newValues[1] < newLow) {
                      this.$nextTick(() => {
                          this.$refs.attentionSlider.setValue([this.attentionValues[0], newValues[1]]);
                      });
                  } else if (newValues[1] > newLow && newValues[1] <= this.sensor.maxAttention && this.slidersEqualedMax) {
                      this.$nextTick(() => {
                          this.$refs.attentionSlider.setValue([this.attentionValues[0], newValues[1]]);
                      });
                  } else {
                      this.slidersEqualedMax = false;
                  }
              }
          }
      if (this.inline) {
        this.$emit('onChange', { sensorId: this.sensor.sensorId, minCrit: this.critValues[0], maxCrit: this.critValues[1], minAttention: this.attentionValues[0], maxAttention: this.attentionValues[1] });
      }
    },
      attentionValues(newValues, oldValues) {
        if ( newValues[0] !== oldValues[0] && this.critValues[0] > newValues[0]){
            this.$nextTick(() => {
                this.$refs.attentionSlider.setValue([this.critValues[0], newValues[1]])
            })
        } else if ( newValues[0] !== oldValues[0] && this.critValues[0] < newValues[0] ){
            this.slidersEqualedMin = false;
        }
        if ( newValues[1] !== oldValues[1] && this.critValues[1] < newValues[1] ){
            this.$nextTick(() => {
                this.$refs.attentionSlider.setValue([newValues[0], this.critValues[1]])
            })
        } else if ( newValues[1] !== oldValues[1] && this.critValues[1] > newValues[1] ){
            this.slidersEqualedMax = false;
        }
        if (this.inline) {
            this.$emit('onChange', { sensorId: this.sensor.sensorId, minCrit: this.critValues[0], maxCrit: this.critValues[1], minAttention: this.attentionValues[0], maxAttention: this.attentionValues[1] });
        }
    },
  },
  methods: {
    applyNewValues() {
      this.$emit('onChange', { id: this.sensor.id, minCrit: this.critValues[0], maxCrit: this.critValues[1], minAttention: this.attentionValues[0], maxAttention: this.attentionValues[1] });
    },
  },
};
</script>

<style lang="scss" scoped>
.sensor-setup {
  padding: 2px 15px;
  position: absolute;
  z-index: 2;
  top: 115%;
  left: -8.9rem;
  width: 24rem;
  background-color: #fff;
  box-shadow: 0 0.5rem 1.5rem 0 rgba(37, 44, 97, 0.15), 0 0.2rem 0.4rem 0 rgba(93, 100, 148, 0.2);
    @media only screen and (max-width: 1199px) {
        left: -14.9rem;
    }

  &.inline {
    position: initial;
    display: inline-block;
    width: 24rem;
    margin-right: 2rem;
    box-shadow: none;

    .triangle {
      display: none;
    }
  }

  .triangle {
    position: absolute;
    top: -1.2rem;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 0;
    height: 0;
    border-left: 1rem solid transparent;
    border-right: 1rem solid transparent;
    border-bottom: 1.2rem solid white;
  }

  .title {
    padding: 1rem;
    color: $grey;
    font-weight: 500;
    span {
      color: $dark;
    }
  }

  .slider {
    margin-top: 1.5rem;
    padding: 0 2.2rem;

    &__header {
      margin-bottom: 12px;
    }
  }

  .footer {
    padding: 1rem;
    display: flex;
    button {
      background-color: $company-color;
      color: white;
      margin-left: auto;
      border: none;
      font-weight: 600;
      font-size: 1rem;
      padding: 0.7rem 1.2rem;
      border-radius: 0.5rem;
      cursor: pointer;
      transition: all 0.4s;

      &:hover {
        background-color: darken($company-color, 10%);
      }
    }
  }
}
</style>
